export default __webpack_public_path__ + "static/media/avatar_72.4319bea6.png";